import React, { useMemo } from 'react';
import { NextPage } from 'next';
import { reduxWrapper } from 'store';
import { RouteMap } from 'constants/Routes';
import useLanguage from 'hooks/useLanguage';

import withForcedRender from 'lib/withForcedRender';
import { REVALIDATE_TIME } from 'constants/Revalidate';
import BrowsePageView from 'views/BrowsePage';
import { browsePageFetcher } from '../learn/utils';

import { ArticleType } from 'types';
import type { IBrowsePageViewProps } from 'views/BrowsePage';

const Page: NextPage<IBrowsePageViewProps> = (props: IBrowsePageViewProps) => {
  const Language = useLanguage();

  const breadcrumbs = useMemo(
    () => [
      {
        label: Language.t('Breadcrumbs.treatment.learn.label'),
        ariaLabel: Language.t('Breadcrumbs.treatment.learn.ariaLabel'),
        to: RouteMap.ARTICLE.base,
        isActive: false,
      },
      {
        label: Language.t('Breadcrumbs.cost.label'),
        ariaLabel: Language.t('Breadcrumbs.cost.ariaLabel'),
        to: RouteMap.BROWSE_OTHER_ARTICLES.path,
        isActive: true,
      },
    ],
    [Language],
  );

  return <BrowsePageView {...props} breadcrumbs={breadcrumbs} />;
};

export const getStaticProps = reduxWrapper.getStaticProps(async ({ store }) => {
  const response = await browsePageFetcher({
    articleType: ArticleType.Cost,
    store,
  });
  if (response.isError) {
    return {
      props: {
        errorPage: response.page,
      },
      revalidate: REVALIDATE_TIME,
    };
  }

  return {
    props: {
      browsePage: response.page,
    },
    revalidate: REVALIDATE_TIME,
  };
});

export default withForcedRender(Page);
